export enum StoreKeys {
  addProductToCartItem = 'addProductToCartItem',
  bundleSearchStore = 'bundleSearchStore',
  cart = 'cart',
  isGuidedFlow = 'isGuidedFlow',
  guidedFlowActiveCategory = 'guidedFlowActiveCategory',
  productCategory = 'productCategory',
  productDetails = 'productDetails',
  removeProductFromCartItem = 'removeProductFromCartItem',
  responseError = 'responseError',
  selectedMobileProductDetails = 'selectedMobileProductDetails',
  selectedNbnProductDetails = 'selectedNbnProductDetails',
  selectedPlanCategory = 'selectedPlanCategory',
  prefillAddress = 'prefillAddress',
  configData = 'configData',
  generalContent = 'generalContent',
  isNbnMovers = 'isNbnMovers',
  currentNbnPlan = 'currentNbnPlan',
  currentMobilePlan = 'currentMobilePlan',
  aemCIFIntegrationEnabled = 'aemCIFIntegrationEnabled',
  customerProfile = 'customerProfile',
  webId = 'webId',
  isCampaignPage = 'isCampaignPage',
  MockEligibility = 'featureFlag.MockAPIs',
  isPromoModalOpen = 'isPromoModalOpen',
  promoModalTriggerElementId = 'promoModalTriggerElementId',
  selectedSKU = 'selectedSKU',
  isPromoModalDlsOpen = 'isPromoModalDlsOpen',
  nbnCommonLinks = 'nbnCommonLinks'
}
